import { OTHER_REASON_PREFIX } from 'src/features/trip/constants';

// The backend stores canceled_reason in a 64-char column, prefix included.
export const MAX_OTHER_REASON_LENGTH = 64 - OTHER_REASON_PREFIX.length;

// Trip.rejected_reason is a 128-char column (canceled_reason is 64).
export const MAX_OTHER_REJECT_REASON_LENGTH = 128 - OTHER_REASON_PREFIX.length;

// No trimming: the single-trip flow only prefixes when text is truthy.
export function composeOtherReason(text: string): string {
  return text ? `${OTHER_REASON_PREFIX}${text}` : 'other';
}

export function parseOtherReason(value: string): {
  reason: string;
  otherText: string;
} {
  if (value.startsWith(OTHER_REASON_PREFIX)) {
    return {
      reason: 'other',
      otherText: value.slice(OTHER_REASON_PREFIX.length),
    };
  }
  return { reason: value, otherText: '' };
}
